import React from 'react';
import { Field } from 'formik';
import { InputGroup } from 'reactstrap';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';
import PasswordStrengthMeter from 'components/PasswordStrengthMeter';
import { security } from 'config/securityFeatures';

const UpdatePasswordForm = (props) => {
  const { handleSubmit, isValid, dirty, isSubmitting, values } = props;
  const { newPassword } = values;
  return (
    <form onSubmit={handleSubmit}>
      <InputGroup className="mt-3" size="medium">
        <Field
          id="oldPassword"
          name="oldPassword"
          type="password"
          component={FormikInputField}
          label="Old Password"
          placeholder="Enter Old Password"
        />
      </InputGroup>

      <InputGroup size="medium">
        <Field
          id="newPassword"
          name="newPassword"
          type="password"
          component={FormikInputField}
          label="New Password"
          placeholder="Enter New Password"
        />
      </InputGroup>
      {/* password strength bar will render here...... 
      The password strength bar imported from components/PasswordStrengthMeter --
       in case password strength bar needs in any other file or project it needs to be there to import */}
      {newPassword && security.showPasswordStrengthBar && (
        <PasswordStrengthMeter password={newPassword} />
      )}

      <LoadingButton
        className="mt-2 btn btn-primary btn-block"
        loading={isSubmitting}
        disabled={!isValid || !dirty || isSubmitting}
        color="primary"
        block
        type="submit"
        size="lg"
      >
        Update
      </LoadingButton>
    </form>
  );
};

export default UpdatePasswordForm;
